<div class="edit-profile-component" [ngClass]="{ 'dx-rtl': rtlEnabled }" dir="{{rtlEnabled ? 'rtl' : 'ltr'}}">
  <dx-popup
  #addUser
  [width]="600"
  [showTitle]="true"
  title="{{ 'HEADER.CHANGE_PROFILE' | translate}}"
  [dragEnabled]="false"
  [closeOnOutsideClick]="false"
  [showCloseButton]="false"
  [rtlEnabled]="rtlEnabled"
  [(visible)]="isOpened">
  <dx-scroll-view width="100%" height="100%">
        <dx-form
            #editProfileForm
            id="editProfileForm"
            [showValidationSummary]="false"
            (onFieldDataChanged)="onFieldDataChanged($event)"
            colCount="auto"
            [(formData)]="model"
            [minColWidth]="500">
            <dxi-item itemType="tabbed">
                <dxi-tab title="{{ 'SHARED.GENERAL' | translate }}">
                  <dxi-item itemType="group">
                    <dxi-item dataField="email" [editorOptions]="{ disabled: true }">
                      <dxo-label text="{{ 'SHARED.EMAIL' | translate }}"></dxo-label>
                      <dxi-validation-rule type="required" message="{{ 'SHARED.EMAIL' | translate }} {{ 'SHARED.IS_REQUIRED' | translate }}"></dxi-validation-rule>
                      <dxi-validation-rule type="email" message="{{ 'SHARED.EMAIL' | translate }} {{ 'SHARED.IS_REQUIRED' | translate }}"></dxi-validation-rule>
                    </dxi-item>
                    <dxi-item dataField="firstname">
                      <dxo-label text="{{ 'SHARED.FIRST_NAME' | translate }}"></dxo-label>
                      <dxi-validation-rule type="required" message="{{ 'SHARED.FIRST_NAME' | translate }} {{ 'SHARED.IS_REQUIRED' | translate }}"></dxi-validation-rule>
                    </dxi-item>
                    <dxi-item dataField="lastname">
                      <dxo-label text="{{ 'SHARED.LAST_NAME' | translate }}"></dxo-label>
                      <dxi-validation-rule type="required" message="{{ 'SHARED.LAST' | translate }} {{ 'SHARED.IS_REQUIRED' | translate }}"></dxi-validation-rule>
                    </dxi-item>
                    <dxi-item dataField="telNumber">
                      <dxo-label text="{{ 'SHARED.TEL_NUMBER' | translate }}"></dxo-label>
                    </dxi-item>
                    <dxi-item dataField="languageId"
                              editorType="dxSelectBox"
                              [editorOptions]="{ items: languages, valueExpr:'languageId' ,
                        displayExpr:'name'}">
                      <dxo-label text="{{ 'USER.PREFERRED_LANGUAGE' | translate }}"></dxo-label>
                    </dxi-item>
                  </dxi-item>
                  
                </dxi-tab>
                <dxi-tab title="{{ 'PLATFORM.TITLE' | translate }}" [disabled]="!isPlatformUser">
                  <dxi-item 
                        dataField="platformRoleId"
                        editorType="dxSelectBox"
                        [editorOptions]="{
                          disabled: true,
                          placeholder: getTranslation(model.platformRole) 
                        }">
                        <dxi-validation-rule type="required" message="{{ 'USER.PLATFORM_ROLE' | translate }}"></dxi-validation-rule>
                    <dxo-label text="{{ 'USER.PLATFORM_ROLE' | translate }}"></dxo-label>
                  </dxi-item>
                </dxi-tab>
                <dxi-tab title="{{ 'SHARED.AUCTION_CLUSTER' | translate }}" [disabled]="!isAuctionClusterUser">
                  <div *dxTemplate>
                  <dx-data-grid
                    [rtlEnabled]="rtlEnabled"
                    [(dataSource)]="model.auctionClusterRoles"
                    [showBorders]="true"
                    [allowColumnReordering]="true" [hoverStateEnabled]="true" [columnAutoWidth]="true"
                    (onInitialized)="initAuctionCluster($event)">
                      <dxi-column
                          dataField="auctionCluster.name"
                          caption="{{ 'SHARED.AUCTION_CLUSTER' | translate }}">
                      </dxi-column>

                      <dxi-column
                        dataField="auction"
                        caption="{{ 'AUCTION.TITLE' | translate }}"
                        cellTemplate="auctionCell">
                      </dxi-column>

                      <dxi-column
                          dataField="auctionClusterRole"
                          caption="{{ 'SHARED.ROLE' | translate }}"
                          cellTemplate="roleCell">
                      </dxi-column>
                      
                      <div *dxTemplate="let data of 'auctionCell'">
                        <span *ngIf="data.value">{{ getTranslation(data.value) }}</span>
                        <span *ngIf="!data.value">{{ 'USER.ALL_AUCTIONS' | translate }}</span>
                      </div>

                      <div *dxTemplate="let data of 'roleCell'">
                        <span *ngIf="data.value">{{ getTranslation(data.value) }}</span>
                      </div>

                    </dx-data-grid>
                    </div>
                </dxi-tab>
                <dxi-tab title="{{ 'SHARED.BUYER' | translate }}" [disabled]="!isBuyerUser">
                  <dxi-item itemType="group" name="buyerRoles" *ngFor="let item of model.buyerRoles; let i=index">
                    
                    <dxi-item [dataField]="item.buyerRole.name" [editorOptions]="{placeholder: getTranslation(item.buyerRole), disabled: true}"><!-- getTranslation()-->
                      <dxo-label text="{{ 'SHARED.ROLE' | translate }}"></dxo-label>
                      <dxi-validation-rule type="required"></dxi-validation-rule>
                    </dxi-item>

                    <dxi-item dataField="'model.buyerRoles[' + i + '].userBuyer.buyer.vat'" [editorOptions]="{ placeholder: item.userBuyer.buyer.vat, disabled: true}">
                      <dxo-label text="{{ 'SHARED.VAT' | translate }}"></dxo-label>
                      <dxi-validation-rule type="required" message="{{ 'SHARED.VAT' | translate }} {{ 'SHARED.IS_REQUIRED' | translate }}"></dxi-validation-rule>
                    </dxi-item>

                    <dxi-item [dataField]="'model.buyerRoles[' + i + '].userBuyer.buyer.name'" [editorOptions]="{ placeholder: item.userBuyer.buyer.name, disabled: true}">
                      <dxo-label text="{{ 'SHARED.NAME' | translate }}"></dxo-label>
                      <dxi-validation-rule type="required" message="{{ 'SHARED.NAME' | translate }} {{ 'SHARED.IS_REQUIRED' | translate }}"></dxi-validation-rule>
                    </dxi-item>

                    <dxi-item [dataField]="'model.buyerRoles[' + i + '].userBuyer.buyer.address1'" [editorOptions]="{ placeholder: item.userBuyer.buyer.address1, disabled: true}">
                      <dxo-label text="{{ 'SHARED.ADDRESS1' | translate }}"></dxo-label>
                      <dxi-validation-rule type="required" message="{{ 'SHARED.ADDRESS1' | translate }} {{ 'SHARED.IS_REQUIRED' | translate }}"></dxi-validation-rule>
                    </dxi-item>

                    <dxi-item [dataField]="'model.buyerRoles[' + i + '].userBuyer.buyer.address2'" [editorOptions]="{ placeholder: item.userBuyer.buyer.address2, disabled: true}">
                      <dxo-label text="{{ 'SHARED.ADDRESS2' | translate }}"></dxo-label>
                    </dxi-item>

                    <dxi-item [dataField]="'model.buyerRoles[' + i + '].userBuyer.buyer.zip'" [editorOptions]="{ placeholder: item.userBuyer.buyer.zip, disabled: true}">
                      <dxo-label text="{{ 'SHARED.ZIP' | translate }}"></dxo-label>
                      <dxi-validation-rule type="required" message="{{ 'SHARED.ZIP' | translate }} {{ 'SHARED.IS_REQUIRED' | translate }}"></dxi-validation-rule>
                    </dxi-item>

                    <dxi-item [dataField]="'model.buyerRoles[' + i + '].userBuyer.buyer.city'" [editorOptions]="{ placeholder: item.userBuyer.buyer.city, disabled: true}">
                      <dxo-label text="{{ 'SHARED.CITY' | translate }}"></dxo-label>
                      <dxi-validation-rule type="required" message="{{ 'SHARED.CITY' | translate }} {{ 'SHARED.IS_REQUIRED' | translate }}"></dxi-validation-rule>
                    </dxi-item>

                    <dxi-item [dataField]="'model.buyerRoles[' + i + '].userBuyer.buyer.country'" [editorOptions]="{ placeholder: item.userBuyer.buyer.country, disabled: true}">
                      <dxo-label text="{{ 'SHARED.COUNTRY' | translate }}"></dxo-label>
                      <dxi-validation-rule type="required" message="{{ 'SHARED.COUNTRY' | translate }} {{ 'SHARED.IS_REQUIRED' | translate }}"></dxi-validation-rule>
                    </dxi-item>

                    <dxi-item [dataField]="'model.buyerRoles[' + i + '].userBuyer.buyer.telNumber'" [editorOptions]="{ placeholder: item.userBuyer.buyer.telNumber, disabled: true}">
                      <dxo-label text="{{ 'SHARED.TEL_NUMBER' | translate }}"></dxo-label>
                      <dxi-validation-rule type="required" message="{{ 'SHARED.TEL_NUMBER' | translate }} {{ 'SHARED.IS_REQUIRED' | translate }}"></dxi-validation-rule>
                    </dxi-item>

                    <dxi-item [dataField]="'model.buyerRoles[' + i + '].userBuyer.buyer.faxNumber'" [editorOptions]="{ placeholder: item.userBuyer.buyer.faxNumber, disabled: true}">
                      <dxo-label text="{{ 'SHARED.FAX_NUMBER' | translate }}"></dxo-label>
                    </dxi-item>

                    <dxi-item [dataField]="'model.buyerRoles[' + i + '].userBuyer.buyer.email'" [editorOptions]="{ placeholder: item.userBuyer.buyer.email, disabled: true}">
                      <dxo-label text="{{ 'SHARED.EMAIL' | translate }}"></dxo-label>
                      <dxi-validation-rule type="required" message="{{ 'SHARED.EMAIL' | translate }} {{ 'SHARED.IS_REQUIRED' | translate }}"></dxi-validation-rule>
                    </dxi-item>

                    <dxi-item [dataField]="'model.buyerRoles[' + i + '].userBuyer.buyer.url'" [editorOptions]="{ placeholder: item.userBuyer.buyer.url, disabled: true}">
                      <dxo-label text="{{ 'SHARED.URL' | translate }}"></dxo-label>
                    </dxi-item>

                  </dxi-item>
                  
                </dxi-tab>
                <dxi-tab title="{{ 'SHARED.SUPPLIER' | translate }}" [disabled]="!isSupplierUser">
                  
                  <dxi-item itemType="group" name="supplierRoles" *ngFor="let item of model.supplierRoles; let i=index">
                    
                    <dxi-item [dataField]="'model.supplierRoles[' + i + '].supplierRole.name'" [editorOptions]="{placeholder: getTranslation(item.supplierRole), disabled: true}">
                      <dxo-label text="{{ 'SHARED.ROLE' | translate }}"></dxo-label>
                      <dxi-validation-rule type="required"></dxi-validation-rule>
                    </dxi-item>

                    <dxi-item [dataField]="'model.supplierRoles[' + i + '].userSupplier.supplier.vat'" [editorOptions]="{ placeholder: item.userSupplier.supplier.vat, disabled: true}">
                      <dxo-label text="{{ 'SHARED.VAT' | translate }}"></dxo-label>
                      <dxi-validation-rule type="required" message="{{ 'SHARED.VAT' | translate }} {{ 'SHARED.IS_REQUIRED' | translate }}"></dxi-validation-rule>
                    </dxi-item>

                    <dxi-item [dataField]="'model.supplierRoles[' + i + '].userSupplier.supplier.name'" [editorOptions]="{ placeholder: item.userSupplier.supplier.name, disabled: true}">
                      <dxo-label text="{{ 'SHARED.NAME' | translate }}"></dxo-label>
                      <dxi-validation-rule type="required" message="{{ 'SHARED.NAME' | translate }} {{ 'SHARED.IS_REQUIRED' | translate }}"></dxi-validation-rule>
                    </dxi-item>

                    <dxi-item [dataField]="'model.supplierRoles[' + i + '].userSupplier.supplier.address1'" [editorOptions]="{ placeholder: item.userSupplier.supplier.address1, disabled: true}">
                      <dxo-label text="{{ 'SHARED.ADDRESS1' | translate }}"></dxo-label>
                      <dxi-validation-rule type="required" message="{{ 'SHARED.ADDRESS1' | translate }} {{ 'SHARED.IS_REQUIRED' | translate }}"></dxi-validation-rule>
                    </dxi-item>

                    <dxi-item [dataField]="'model.supplierRoles[' + i + '].userSupplier.supplier.address2'" [editorOptions]="{ placeholder: item.userSupplier.supplier.address2, disabled: true}">
                      <dxo-label text="{{ 'SHARED.ADDRESS2' | translate }}"></dxo-label>
                    </dxi-item>

                    <dxi-item [dataField]="'model.supplierRoles[' + i + '].userSupplier.supplier.zip'" [editorOptions]="{ placeholder: item.userSupplier.supplier.zip, disabled: true}">
                      <dxo-label text="{{ 'SHARED.ZIP' | translate }}"></dxo-label>
                      <dxi-validation-rule type="required" message="{{ 'SHARED.ZIP' | translate }} {{ 'SHARED.IS_REQUIRED' | translate }}"></dxi-validation-rule>
                    </dxi-item>

                    <dxi-item [dataField]="'model.supplierRoles[' + i + '].userSupplier.supplier.city'" [editorOptions]="{ placeholder: item.userSupplier.supplier.city, disabled: true}">
                      <dxo-label text="{{ 'SHARED.CITY' | translate }}"></dxo-label>
                      <dxi-validation-rule type="required" message="{{ 'SHARED.CITY' | translate }} {{ 'SHARED.IS_REQUIRED' | translate }}"></dxi-validation-rule>
                    </dxi-item>

                    <dxi-item [dataField]="'model.supplierRoles[' + i + '].userSupplier.supplier.country'" [editorOptions]="{ placeholder: item.userSupplier.supplier.country, disabled: true}">
                      <dxo-label text="{{ 'SHARED.COUNTRY' | translate }}"></dxo-label>
                      <dxi-validation-rule type="required" message="{{ 'SHARED.COUNTRY' | translate }} {{ 'SHARED.IS_REQUIRED' | translate }}"></dxi-validation-rule>
                    </dxi-item>

                    <dxi-item [dataField]="'model.supplierRoles[' + i + '].userSupplier.supplier.telNumber'" [editorOptions]="{ placeholder: item.userSupplier.supplier.telNumber, disabled: true}">
                      <dxo-label text="{{ 'SHARED.TEL_NUMBER' | translate }}"></dxo-label>
                      <dxi-validation-rule type="required" message="{{ 'SHARED.TEL_NUMBER' | translate }} {{ 'SHARED.IS_REQUIRED' | translate }}"></dxi-validation-rule>
                    </dxi-item>

                    <dxi-item [dataField]="'model.supplierRoles[' + i + '].userSupplier.supplier.faxNumber'" [editorOptions]="{ placeholder: item.userSupplier.supplier.faxNumber, disabled: true}">
                      <dxo-label text="{{ 'SHARED.FAX_NUMBER' | translate }}"></dxo-label>
                    </dxi-item>

                    <dxi-item [dataField]="'model.supplierRoles[' + i + '].userSupplier.supplier.email'" [editorOptions]="{ placeholder: item.userSupplier.supplier.email, disabled: true}">
                      <dxo-label text="{{ 'SHARED.EMAIL' | translate }}"></dxo-label>
                      <dxi-validation-rule type="required" message="{{ 'SHARED.EMAIL' | translate }} {{ 'SHARED.IS_REQUIRED' | translate }}"></dxi-validation-rule>
                    </dxi-item>

                    <dxi-item [dataField]="'model.supplierRoles[' + i + '].userSupplier.supplier.url'" [editorOptions]="{ placeholder: item.userSupplier.supplier.url, disabled: true}">
                      <dxo-label text="{{ 'SHARED.URL' | translate }}"></dxo-label>
                    </dxi-item>

                  </dxi-item>

                </dxi-tab>
            </dxi-item>
            
        </dx-form>
<div class="au-dx-popup-padder">
          <button type="submit" class="btn btn-primary" (click)="onDelete();">{{ 'SHARED.DELETE' | translate }}</button>
          <button type="submit" class="btn btn-primary" (click)="onSubmit();" name="btnEditProfileSubmit">
            {{ 'SHARED.SAVE' | translate }}
          </button>
          <button type="button" class="btn btn-outline" (click)="onCancel();">{{ 'SHARED.CANCEL' | translate }}</button>
          </div>
</dx-scroll-view>
</dx-popup>
</div>
<confirmation-component #confirmation title="{{ 'USER.ACCOUNT_DELETE_HEADER' | translate }}" message="{{ 'USER.ACCOUNT_DELETE' | translate }}" buttonCloseText="{{ 'SHARED.DELETE' | translate }}" cancellable="true" (close)="deleteSelected();"></confirmation-component>
<save-confirmation-component #saveConfirmation title="{{ 'SHARED.LEAVE_PAGE' | translate }}" buttonCloseText="{{ 'SHARED.OK' | translate }}" cancellable="true" (close)="onCancel();"></save-confirmation-component>
